<template>
 <div class="mt-5">
    <v-row no-gutters>
      <v-col class="ml-4 font18" :class="{ bold: !$isTargetShop }" :style="'color:' + $CUSTOMMainTextColor">{{ $t("message.allReward") }}</v-col>
    </v-row>
    <div v-if="loadReward === true " style="height: 40vh;
    display: flex;
    justify-content: center;
    align-items: center;">
      <v-progress-circular
      :size="30"
      color="primary"
      indeterminate>
    </v-progress-circular>
    </div>
    <v-card
      v-for="(item, i) in items"
      :key="i"
      class="ml-4 mr-4 mb-5 mt-4"
      :style="($isTargetShop ? 'border-radius: 0px;box-shadow: none;' : 'border-radius: 12px;') + 'padding: 10px 0px 10px 10px;'"
      width="93%"
      :elevation="$isTargetShop ? 0 : 3"
      flat
      title
    >
       <div style="display: flex">
        <div style="height: 120px; width: 122px">
          <v-img
            :src="item.pictureUrl"
            width="140"
            class="link"
            :style="(item.quotaCode <= 0? 'opacity: 0.5;' : 'opacity: 1;') + 'border-radius: ' + ($isTargetShop ? '0px' : '12px') + ';'"
            @click="$router.push(`/C/reward/detail/${item.rewardId}`)"
            cover
          >
            <div v-if="item.levelNm !== 'All Level'">
              <div
                :style="
                  'width: 150px;' +
                  'height: 2px;' +
                  'transform: rotate(-30deg);' +
                  'position:absolute;' +
                  'top:0;' +
                  'left:-50px;' +
                  'background-color:' +
                  item.color
                "
              ></div>
              <div
                :style="`width: 180px;height: 2px;background-color: ${item.color};transform: rotate(-30deg);position:absolute;top:2px;left:-20px;`"
              ></div>
              <div
                :style="`height:20px;position:absolute;right:30px;top:4px;width:130px;background-color:${item.color};transform: rotate(-30deg);text-align:center;color:white;text-shadow: 1px 1px #000000; `"
              >
                <p style="font-size: 12px">{{ item.levelNm }}</p>
              </div>
            </div>
          </v-img>
        </div>
        <div style="padding: 8px; position: relative; width: 100vh">
          <div height="100" v-if="$i18n.locale === 'en' && item.nameEng !== '' && item.nameEng !== null">
            <div :class="{ bold: !$isTargetShop }" :style="'color:' + $CUSTOMMainTextColor + (!$isTargetShop ? ';font-size:16px;margin-bottom:8px;' : '')" @click="$router.push(`/C/reward/detail/${item.rewardId}`)">{{ item.nameEng.substring(0, 18) }}</div>
          </div>
          <div height="100" v-else>
            <div :class="{ bold: !$isTargetShop }" :style="'color:' + $CUSTOMMainTextColor + (!$isTargetShop ? ';font-size:16px;margin-bottom:8px;' : '')" @click="$router.push(`/C/reward/detail/${item.rewardId}`)">{{ item.name.substring(0, 18) }}</div>
          </div>
          <div height="100" v-show="item.name.length <= 49">
            <div :style=" (!$isTargetShop ? ';font-size:16px;margin-bottom:8px;' : '')"  @click="$router.push(`/C/reward/detail/${item.rewardId}`)">{{ item.subName.substring(0, 41) }}</div>
          </div>
          <div v-if="item.supply === 'จัดส่ง'" height="100">
            <div class="font14"><v-icon>mdi-cube-send</v-icon> {{ $t("message.delivery") }}</div>
          </div>
          <div v-if="item.supply === 'admin'" height="100">
            <div class="font14"><v-icon>mdi-comment-account</v-icon> {{ 'admin' }}</div>
          </div>
          <div v-if="item.supply === 'รับหน้าร้าน' && !$isTargetShop()" height="100" class="mb-3">
            <div class="font14"><v-icon>mdi-store</v-icon>{{ item.shopId === 'U2ad4ca7a5c84fbe7358b56f54af919fa' ? 'รับที่สำนักงานโครงการ' : $t("message.ReceiveAtStore") }}</div>
          </div>
              <div v-if="$isTargetShop && item.endDate" height="100" class="mb-3">
              <div style="font-size: 12px;margin-top:8px">
                ใช้ก่อนวันที่ {{
                  (() => {
                    const d = new Date(item.endDate);
                    const en = d.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
                    // en = "Feb 8, 2026"
                    const [month, day, year] = en.replace(',', '').split(' ');
                    const thMonths = {
                      Jan: 'ม.ค.', Feb: 'ก.พ.', Mar: 'มี.ค.', Apr: 'เม.ย.', May: 'พ.ค.', Jun: 'มิ.ย.',
                      Jul: 'ก.ค.', Aug: 'ส.ค.', Sep: 'ก.ย.', Oct: 'ต.ค.', Nov: 'พ.ย.', Dec: 'ธ.ค.'
                    };
                    return `${parseInt(day)} ${thMonths[month]} ${year}`;
                  })()
                }}
              </div>
          </div>
          <div style="position: absolute;bottom: 3px;width: 91%;">
            <v-btn
              v-if="item.quotaCode > 0"
              :class="$isTargetShop ? '': 'bold'"
              block
              :style="($isTargetShop ? 'color: #000;background-color: #FFA300;box-shadow: none;border-radius: 0px;' : 'color:' + $textcolor + ';background-color:' + $bgColor + ';border-radius: 8px;') +
              'text-align: center;display:flex;padding:3px;font-size: 15px;justify-content: center;'"
              @click="checkLevelAndCoin(item)"
              >
              <div v-if="!$isTargetShop()" class="">
                <img
                  v-if="profile.pictureUrl && !$isTargetShop()"
                  style="
                    border-color: white;
                    height: 22px;
                    margin-right:5px;
                    padding-bottom: 4px;
                  "
                  alt="Avatar"
                  :src="require('@/assets/coin.png')"
                />
                <img
                v-else
                class="ps-1"
                style="
                  border-color: white;
                  height: 20px;
                  margin-right: 4px;
                "
                alt="Avatar"
                :src="$images.point"
              />
              </div>
              <div v-if="item.supply !== 'admin'">
                <div v-if="item.resale && item.resale > 0" style="
                  display: flex;
                  align-items: center;">
                <div :style="$isTargetShop? 'color: #000' : 'color:' + $textcolor"
                  >{{item.resale}}
                </div>
                <div v-if="item.resale" style="color: rgb(236 229 229); text-decoration: line-through;margin-left:5px;font-size: 15px;"
                  >
                  {{ formatNumber(item.point)}}
                </div>
                </div>
                <div v-else>
                  <div :style="$isTargetShop? 'color: #000' : 'color:' + $textcolor">
                    {{ formatNumber(item.point)}}
                  </div>
                </div>
              </div>
              <div v-else>
                <strong v-if="!$isTargetShop()" class="text-center" color="#181446"
                  >{{ findPointToRedeem(item.levelSettingsReward) }}
                </strong>
                <span v-else>{{ findPointToRedeem(item.levelSettingsReward) }}
                </span>
            </div>
            <div v-if="$isTargetShop()" class="">
                <img
                  v-if="profile.pictureUrl && !$isTargetShop()"
                  style="
                    border-color: white;
                    height: 22px;
                    margin-right:5px;
                    padding-bottom: 4px;
                  "
                  alt="Avatar"
                  :src="require('@/assets/coin.png')"
                />
                <img
                v-else
                class="ps-1"
                style="
                  border-color: white;
                  height: 20px;
                  margin-right: 4px;
                "
                alt="Avatar"
                :src="$images.point"
              />
                         </div>
            </v-btn>
            <v-btn
              v-if="item.quotaCode <= 0"
              small
              disabled
              class="pa-0 mr-3 mb-3 font17 bold"
              style="
                width: 100px;
                position: absolute;
                bottom: 0;
                right: 0;
                text-align: center;
              "
              >สินค้าหมด</v-btn
            >
          </div>
          <!-- <div>
            <v-card
              v-if="item.quotaCode > 0"
              class="pa-0 mr-3 mb-3 font17 bold"
              style="
                width: 100px;
                position: absolute;
                bottom: 0;
                right: 0;
                color: #fff;
                background-color: #d82148;
                text-align: center;
              "
              @click="checkLevelAndCoin(item)"
              >
              <img
                  v-if="profile.pictureUrl"
                  style="
                    border-color: white;
                    height: 22px;
                    margin-right:5px;
                    padding-bottom: 4px;
                  "
                  alt="Avatar"
                  :src="require('@/assets/coin.png')"
                />{{ formatNumber(item.point) }}
              </v-card>
            <v-btn
              v-if="item.quotaCode <= 0"
              small
              disabled
              class="pa-0 mr-3 mb-3 font17 bold"
              style="
                width: 100px;
                position: absolute;
                bottom: 0;
                right: 0;
                text-align: center;
              "
              >สินค้าหมด</v-btn
            >
          </div> -->
        </div>
      </div>
    </v-card>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import Swal from 'sweetalert2'
export default {
  name: 'AllRewards',
  data () {
    return {
      id: this.$route.params.id,
      items: null,
      member: null,
      profile: null,
      DateNow: new Date(),
      load: false,
      loadReward: null
    }
  },
  computed: {
    shopId () {
      return this.member && this.member.shopId ? this.member.shopId : null
    }
  },
  async mounted () {
    this.member = this.GET_MEMBERINFO()
    this.profile = this.getLiffProfile()
    await this.getReward()
  },
  methods: {
    ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO']),

    async checkLevelAndCoin (items) {
      this.load = true
      if (items.levelNm === 'All Level') {
        if (this.member.currentPoint >= items.point) {
          if (items.supply === 'จัดส่ง') {
            this.$router.push(`/C/reward/detail/${items.rewardId}`)
          } else {
            this.load = await this.redeemReward(items)
            this.member = this.GET_MEMBERINFO()
          }
        } else if (this.member.currentPoint < items.point) {
          const Toast = Swal.mixin({
            toast: true,
            position: 'center',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonColor: '#6ECB63',
            confirmButtonText: `${this.$t('message.confirm')}`,
            cancelButtonText: `${this.$t('message.cancle')}`
          })
          Toast.fire({
            icon: 'error',
            width: 3000,
            title: `${this.$t('message.pointInsufficient')}  :( `,
            html: `${this.$t('message.howToGetPoint')}`,
            backdrop: `rgba(0,0,001,0.4)`
          }).then((confirm) => {
            if (confirm.isConfirmed) {
              this.$router.push('/HowToGetCoin')
            }
          })
        }
      } else if (items.levelNm !== 'All Level') {
        // console.log(' not All Level', items)
        // console.log('this.member', this.member)
        if (this.member.levelPoint >= items.levelPoint) {
          if (this.member.currentPoint >= items.point) {
            if (items.supply === 'จัดส่ง') {
              this.$router.push(`/C/reward/detail/${items.rewardId}`)
            } else {
              this.load = await this.redeemReward(items)
              this.member = this.GET_MEMBERINFO()
            }
          } else if (this.member.currentPoint < items.point) {
            const Toast = Swal.mixin({
              toast: true,
              position: 'center',
              showConfirmButton: true,
              showCancelButton: true,
              confirmButtonColor: '#6ECB63',
              confirmButtonText: `${this.$t('message.confirm')}`,
              cancelButtonText: `${this.$t('message.cancle')}`
            })
            Toast.fire({
              icon: 'error',
              width: 3000,
              title: `${this.$t('message.pointInsufficient')}  :( `,
              html: `${this.$t('message.howToGetPoint')}`,
              backdrop: `rgba(0,0,001,0.4)`
            }).then((confirm) => {
              if (confirm.isConfirmed) {
                this.$router.push('/HowToGetCoin')
              }
            })
          }
        } else if (this.member.levelPoint < items.levelPoint) {
          const Toast = Swal.mixin({
            toast: true,
            position: 'center',
            showConfirmButton: true,
            confirmButtonColor: '#6ECB63',
            confirmButtonText: `${this.$t('message.ok')}`
          })
          Toast.fire({
            icon: 'error',
            width: 3000,
            title: `${this.$t('message.memberInsufficient')}  :( `,
            html:
              `${this.$t('message.redeemLevel')}  :( ` +
              items.levelNm +
              `${this.$t('message.orHight')}  :( `,
            backdrop: `rgba(0,0,001,0.4)`
          }).then((confirm) => {
            if (confirm.isConfirmed) {
              this.$router.push('/tierBenefit')
            }
          })
        }
      }
    },
    async getReward () {
      this.loadReward = true
      const result = await this.callBeTaskAPI(
        'get',
        '/reward/getColor?RECORD_STATUS=N'
      )
      if (Array.isArray(result)) {
        let a = result.filter(item => item.expireTypeReward === 'FixDate' && moment(this.DateNow).format('YYYY-MM-DD') >= moment(item.startDate).format('YYYY-MM-DD') && moment(this.DateNow).format('YYYY-MM-DD') < moment(item.endDate).format('YYYY-MM-DD'))
        result.map(item => item.expireTypeReward === 'Redeem' ? a.push(item) : null)
        this.items = a.sort((a, b) => { return a.point - b.point })
        this.items = this.items.filter(item => item.showReward !== 'False')
        this.items = this.items.filter(item => item.rewardId !== 338).filter((item2) => {
          if (item2.supply === 'admin') {
            if (item2.levelSettingsReward) {
              const levelSettings = JSON.parse(item2.levelSettingsReward)

              if (Array.isArray(levelSettings)) {
                return levelSettings.some(data =>
                  data.levelId.toString() === this.member.levelId && data.enabled === true
                )
              }
            }
          } else {
            return item2
          }
        }) // สิทฺธิชิงโชคลิน
      }
      this.loadReward = false
    },
    findPointToRedeem (item) {
      try {
        const levelSettings = JSON.parse(item)
        if (Array.isArray(levelSettings)) {
          const matched = levelSettings.find(data =>
            data.levelId.toString() === this.member.levelId && data.enabled === true
          )
          return matched ? matched.points : null
        }

        return null
      } catch (error) {
        console.error('findPointToRedeem error', error)
      }
    }
  }
}
</script>
<style scoped>
/* .ticket::after {
    content: '';
    width:25px;
    height: 25px;
    border-radius: 50%;
    position: absolute;
    bottom: -12px;
    left: -11px;
    background-color: #F7F7F7;
}
.ticket{
  background: white;
    border-radius: 15px 15px 8px 8px;
    box-shadow: 21px 35px 31px -9px rgba(0,0,0,0.22);
    position: relative;
} */
.resale {
  margin-left:5px;font-size: 12px;
  display: flex;
  align-items: center;
  color: rgb(236 229 229);
  text-decoration: line-through;
}
</style>



// WEBPACK FOOTER //
// src/components/HomeCUSTOM/Reward/AllRewards.vue